



















































































































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import Moment from "moment-timezone";
import DetailModal from "./billdetailed.vue";
import BillsPay from "./billspay.vue";
import PayBillPO from "@/store/entities/finance/paybillspo";
import ReductionPO from "@/store/entities/finance/reductionpo";
import Reduction from "./reduction.vue";
import printformat from "@/lib/Common/printformt";
import { getLodop } from "@/assets/lodop/lodopFun";
import SearchTree from "@/lib/Common/searchtree";

class PageBillsRequest extends PageRequest {
  keyword: string;
  areaId: number;
  controlType: number = 0;
  payMark: number = 0;
  isEnable: number = 9;
  startTime: string;
  endTime: string;
}

@Component({
  components: { DetailModal, BillsPay, Reduction },
})
export default class Bills extends AbpBase {
  //filters
  pagerequest: PageBillsRequest = new PageBillsRequest();
  reductionpo: ReductionPO = new ReductionPO();
  areaTree: any[] = [];
  areaTreeList: any[] = [];
  searchName: string = "";
  customerlist: any[] = [];
  billId: string = null;
  billNo: string = null;
  chooseId: Array<any> = [];
  paybillPo: PayBillPO = new PayBillPO();
  detailModalShow: boolean = false; //显示明细窗口
  payModalShow: boolean = false; //显示支付窗口
  spinShow: boolean = false; //显示加载
  reductionModalShow: boolean = false; //显示调整窗口
  height: number = 300;
  btnloading: boolean = false; //按钮状态
  splitnum: number = 0.15;

  get list() {
    return this.$store.state.bills.list;
  }
  get loading() {
    return this.$store.state.bills.loading;
  }
  getItemId() {
    let item = (this.$refs.tree as any).getSelectedNodes();
    if (item.length > 0) {
      this.pagerequest.areaId = item[0].id;
    }
    this.$store.commit("bills/setCurrentPage", 1);
    this.getpage();
  }
  //搜索树形结构
  searchTree(value: any, treeList) {
    if (!value) {
      this.areaTree = this.areaTreeList;
      return;
    }
    this.areaTree = SearchTree.searnchTree(value, treeList);
  }
  //区域
  async getAreaTree() {
    await this.$store
      .dispatch("area/getAreaLeftTree")
      .then((val) => {
        this.areaTree = val;
        this.areaTreeList = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  pageChange(page: number) {
    this.$store.commit("bills/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("bills/setPageSize", pagesize);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "bills/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.bills.pageSize;
  }
  get totalCount() {
    return this.$store.state.bills.totalCount;
  }
  get currentPage() {
    return this.$store.state.bills.currentPage;
  }
  //选择
  onrowselect(val, index) {
    this.billId = index.id;
    this.billNo = index.billNo;
    this.chooseId.push(index.id);
  }
  //取消选择
  onrowselected(val, index) {
    if (this.chooseId.length == 0) {
    } else {
      this.chooseId = this.chooseId.filter((ele) => ele != index.id);
    }
  }
  //排序
  changeSort(key) {
    if (key.order !== "normal") {
      this.pagerequest.sorting = key.key + " " + key.order;
    }
    this.getpage();
  }
  //列名
  columns = [
    {
      type: "index",
      key: "index",
      width: 60,
      fixed: "left",
      align: "left",
      title: this.L("IndexNo"),
    },
    {
      type: "selection",
      key: "selection",
      fixed: "left",
      width: 60,
      align: "center",
    },
    {
      sortable: true,
      title: this.L("BillNo"),
      key: "billNo",
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.billNo,
            },
          },
          params.row.billNo
        );
      },
    },

    {
      title: this.L("Customer"),
      key: "customerName",
      width: 130,
      fixed: "left",
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.customerName,
            },
          },
          params.row.customerName
        );
      },
    },
    {
      sortable: true,
      title: this.L("TotalUse"),
      key: "billUse",
      width: 130,
    },
    {
      title: this.L("BaseFee"),
      key: "baseAmmount",
      width: 130,
    },
    {
      title: this.L("TimeSharingAmmount"),
      key: "timeSharingAmmount",
      width: 130,
    },
    {
      title: this.L("AllocationAmmount"),
      key: "allocationAmmount",
      width: 130,
    },
    {
      title: this.L("PublicConstructionAmmount"),
      key: "publicConstructionAmmount",
      width: 130,
    },
    {
      title: this.L("BillAmmount"),
      key: "billAmmount",
      width: 130,
    },
    {
      title: this.L("LastAmmount"),
      key: "lastBalance",
      width: 130,
    },
    {
      title: this.L("TotalAmmount"),
      key: "totalAmount",
      width: 130,
    },
    {
      title: this.L("AveragePrice"),
      key: "averagePrice",
      width: 130,
    },
    {
      sortable: true,
      title: this.L("PayMark"),
      key: "payMark",
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.payMark == 1 ? this.L("已支付") : this.L("未支付")
        );
      },
    },
    {
      title: this.L("IsReduction"),
      key: "isReduction",
      sortable: true,
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.isReduction == 2
            ? this.L("Reductioned")
            : this.L("NoReduction")
        );
      },
    },
    {
      title: this.L("ReductionNum"),
      key: "reductionNum",
      sortable: true,
      width: 130,
    },
    {
      title: this.L("ReductionTotal"),
      key: "reductionTotal",
      sortable: true,
      width: 130,
    },
    {
      title: this.L("ReductionTime"),
      key: "reductionTime",
      sortable: true,
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.reductionTime == null
            ? ""
            : Moment(params.row.reductionTime).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      sortable: true,
      title: this.L("ControleType"),
      key: "controlType",
      width: 110,
      render: (h: any, params: any) => {
        let id = params.row.controlType;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      title: this.L("Mobile"),
      key: "customerMobile",
      width: 130,
    },
    {
      title: this.L("LateTime"),
      key: "lateTime",
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.lateTime == null
            ? ""
            : Moment(params.row.lateTime).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      sortable: true,
      title: this.L("LatePrice"),
      key: "latePrice",
      width: 130,
    },
    {
      sortable: true,
      title: this.L("LateFee"),
      key: "lateFee",
      width: 130,
    },
    {
      title: this.L("PrintNum"),
      key: "printNum",
      width: 130,
    },
    {
      title: this.L("FirstBillDate"),
      key: "statementDate",
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.statementDate == null
            ? ""
            : Moment(params.row.statementDate).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      title: this.L("StartDate"),
      key: "startDate",
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.startDate == null
            ? ""
            : Moment(params.row.startDate).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      title: this.L("EndDate"),
      key: "endDate",
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.endDate == null
            ? ""
            : Moment(params.row.endDate).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },

    {
      title: this.L("BankName"),
      key: "bankName",
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.bankName,
            },
          },
          params.row.bankName
        );
      },
    },
    {
      title: this.L("PayerBankNo"),
      key: "bankNo",
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.bankNo,
            },
          },
          params.row.bankNo
        );
      },
    },
    {
      title: this.L("BankAddress"),
      key: "bankAddress",
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.bankAddress,
            },
          },
          params.row.bankAddress
        );
      },
    },

    {
      title: this.L("Organizations"),
      key: "organizationId",
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.organizationId;
        let ite = JSON.parse(localStorage.getItem("organizations"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h(
          "span",
          info.length > 0 ? info[0].displayName : this.L("Unknown")
        );
      },
    },
    {
      title: this.L("Areas"),
      key: "areaId",
      sortable: true,
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.areaId;
        let ite = JSON.parse(localStorage.getItem("areas"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h(
          "span",
          info.length > 0 ? info[0].fullName : this.L("Unknown")
        );
      },
    },
    {
      sortable: true,
      title: this.L("SortName"),
      key: "sortCode",
      width: 90,
    },
    {
      title: this.L("Description"),
      key: "description",
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.description,
            },
          },
          params.row.description
        );
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 200,
      sortId: 30,
      fixed: "right",
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("ConfirmCanceBaseFee"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      this.canceBaseFee(params.row);
                    },
                  });
                },
              },
            },
            this.L("CanceBaseFee")
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("ConfirmRecoveryBaseFee"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      this.recoveryBaseFee(params.row);
                    },
                  });
                },
              },
            },
            this.L("RecoveryBaseFee")
          ),
        ]);
      },
    },
  ];
  async created() {
    this.getAreaTree();
    this.getItemDetail();
    this.reductionpo.billsId = [];
    this.pagerequest.startTime = Moment()
      .day(-31)
      .startOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.pagerequest.endTime = Moment()
      .endOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.getpage();
  }

  // 时间触发
  changeTime(time) {
    this.pagerequest.startTime = Moment(
      time[0] == "" ? new Date() : time[0],
      "YYYY-MM-DD HH:mm:ss"
    )
      .startOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.pagerequest.endTime = Moment(time[1] == "" ? new Date() : time[1])
      .endOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.getpage();
  }
  //导出数据
  async exportData(type: any) {
    //console.log(type);
    let fileName = Moment().format("x");
    if (type === 'exportCurrentPage') {//当前页数据
      (this.$refs.selection as any).exportCsv({ filename: fileName, original: false });
    } else {
      this.pagerequest.skipCount = 0;
      this.pagerequest.maxResultCount = 10000;
      await this.$store.dispatch({
        type: "meter/getAll",
        data: this.pagerequest,
      });
      (this.$refs.selection as any).exportCsv({ filename: fileName, original: false, data: this.$store.state.meter.list });
    }
  }
  data() {
    return {
      paymentType: [],
      controleType: [],
      pageSizeOpts: [10, 20, 50, 100, 200],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
      datepicker: {
        shortcuts: [
          {
            text: this.L("OneWeek"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              return [start, end];
            },
          },
          {
            text: this.L("OneMonth"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
              return [start, end];
            },
          },
          {
            text: this.L("ThreeMonths"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
              return [start, end];
            },
          },
        ],
      },
    };
  }
  getItemDetail() {
    if (localStorage.getItem("itemdetail") === null) {
      this.$store.dispatch({
        type: "itemdetail/getdetailtolocalstorge",
      });
    }
    let detaillist = JSON.parse(localStorage.getItem("itemdetail"));
    if (detaillist.length > 0) {
      let pay = detaillist.filter((p) => {
        return p.itemId == 2;
      });
      pay.forEach((ele) => {
        this.$data.paymentType.push({ label: ele.name, value: ele.id });
      });
      let control = detaillist.filter((p) => {
        return p.itemId == 14;
      });
      control.forEach((ele) => {
        this.$data.controleType.push({ label: ele.name, value: ele.id });
      });
    }
  }
  geSort(key) {
    if (key.order !== "normal") {
      this.pagerequest.sorting = key.key + " " + key.order;
    }
    this.getpage();
  }
  //列合计
  handleSummary({ columns, data }) {
    //console.log(data);
    const sums = {};
    columns.forEach((column, index) => {
      //console.log(index)
      const key = column.key;
      if (key === "billNo") {
        sums[key] = {
          key,
          value: this.L("Total"),
        };
        return;
      } else if (
        key === "billUse" ||
        key === "lastBalance" ||
        key === "billAmmount" ||
        key === "totalAmount" ||
        key === "lateFee"
      ) {
        const values = data.map((item) => Number(item[key]));
        if (!values.every((value) => isNaN(value))) {
          const v = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[key] = {
            key,
            value: v.toFixed(4),
          };
        } else {
          sums[key] = {
            key,
            value: "N/A",
          };
        }
      } else {
        const key = column.key;
        sums[key] = {
          key,
          value: "",
        };
      }
    });
    return sums;
  }
  //查看明细
  async detailing() {
    let val = (this.$refs.selection as any).getSelection();
    if (val.length == 0 || val.length > 1) {
      this.$Modal.info({
        title: this.L("Tips"),
        content: this.L("PleasChoose") + this.L("One") + this.L("Record"),
      });
      return;
    }
    this.billId = val[0].id;
    this.detailModalShow = true;
  }
  //支付
  async payform() {
    let val = (this.$refs.selection as any).getSelection();
    if (val.length == 0) {
      this.$Modal.info({
        title: this.L("Tips"),
        content: this.L("PleasChoose") + this.L("One") + this.L("Record"),
      });
      return;
    }
    let isre = false;
    let cid = val[0].customerName;
    let ispay = false;
    val.forEach((ele) => {
      if (ele.customerName != cid) {
        isre = true;
        return;
      }
      if (ele.payMark == 1) {
        ispay = true;
        return;
      }
    });
    if (ispay) {
      this.$Modal.info({
        title: this.L("Tips"),
        content: this.L("Payed"),
      });
      return;
    }
    if (isre) {
      this.$Modal.info({
        title: this.L("Tips"),
        content: this.L("OnlyCustomer"),
      });
      return;
    }
    this.paybillPo.billsId = [];
    val.forEach((ele) => {
      this.paybillPo.billsId.push(ele.id);
    });
    let item = await this.$store.dispatch({
      type: "paybills/getbillinfo",
      data: this.paybillPo,
    });
    this.$store.commit("paybills/edit", item);
    this.payModalShow = true;
  }
  //打印
  async print() {
    let val = (this.$refs.selection as any).getSelection();
    if (val.length == 0) {
      this.$Modal.info({
        title: this.L("Tips"),
        content: this.L("PleasChoose") + this.L("One") + this.L("Record"),
      });
      return;
    }
    let idlist: any[] = [];
    val.forEach((ele) => {
      idlist.push(ele.id);
    });
    let res = await this.$store
      .dispatch({
        type: "bills/printbills",
        data: idlist,
      })
      .catch((err) => {
        this.spinShow = false;
        this.$Modal.info({
          title: this.L("Tips"),
          content: err,
        });
      });
    this.spinShow = false;
    this.$Modal.info({
      title: this.L("Tips"),
      content: res.data.result.message,
    });
    //console.log(res)
    if (res.data.result.isSuccess) {
      if (res.data.result.printInfo.length > 0) {
        const LODOP = getLodop();
        LODOP.PRINT_INIT(res.data.result.commpanyName);
        LODOP.SET_PRINT_MODE("PROGRAM_CONTENT_BYVAR", true);
        LODOP.SET_LICENSES("光芮（上海）化妆品有限公司", "1F68AC11AB0D5C1DD939D05CDF366EE8", "光芮（上海）化妝品有限公司", "995D1AE6BBB182F737B64A997DAED9CE");
        LODOP.SET_LICENSES("THIRD LICENSE", "", "glo & ray(Shanghai) Cosmetics Co., Ltd.", "04CF04878BBF0CAAB2CDD4E4EB01FD27");
        res.data.result.printInfo.forEach((ele) => {
          LODOP.NewPageA();
          let lodoinfo = printformat.lodopinfo(ele);
          lodoinfo.forEach((ele) => {
            //console.log(ele)
            switch (ele.key) {
              case "LODOP.PRINT_INIT": //打印初始化PRINT_INIT(strTaskName)
                LODOP.PRINT_INIT(ele.name);
                break;
              case "LODOP.PRINT_INITA": //(扩展型)打印初始化(Top,Left,Width,Height,strPrintName)
                LODOP.PRINT_INITA(
                  ele.intTop,
                  ele.intLeft,
                  ele.intWidth,
                  ele.intHeight,
                  ele.name
                );
                break;
              case "LODOP.SET_PRINT_PAGESIZE": //设定纸张大小(intOrient, PageWidth,PageHeight,strPageName)
                LODOP.SET_PRINT_PAGESIZE(
                  ele.intOrient,
                  ele.intPageWidth,
                  ele.intPageWidth,
                  ele.strPageName
                );
                break;
              case "LODOP.ADD_PRINT_HTM": //增加超文本打印项(普通模式)(Top,Left,Width,Height,strHtmlContent)
                LODOP.ADD_PRINT_HTM(
                  ele.intTop,
                  ele.intLeft,
                  ele.intWidth,
                  ele.intHeight,
                  ele.strContent
                );
                break;
              case "LODOP.ADD_PRINT_TEXT": //增加纯文本打印项(Top,Left,Width,Height,strContent)
                LODOP.ADD_PRINT_TEXT(
                  ele.intTop,
                  ele.intLeft,
                  ele.intWidth,
                  ele.intHeight,
                  ele.strContent
                );
                break;
              case "ADD_PRINT_IMAGE": //增加图片打印项(Top,Left,Width,Height,strHtmlContent)
                LODOP.ADD_PRINT_IMAGE(
                  ele.intTop,
                  ele.intLeft,
                  ele.intWidth,
                  ele.intHeight,
                  ele.strContent
                );
                break;
              case "LODOP.ADD_PRINT_RECT": //增加矩形线ADD_PRINT_RECT(Top, Left, Width, Height,intLineStyle, intLineWidth)
                LODOP.ADD_PRINT_RECT(
                  ele.intTop,
                  ele.intLeft,
                  ele.intWidth,
                  ele.intHeight,
                  ele.intLineStyle,
                  ele.intLineWidth
                );
                break;
              case "LODOP.ADD_PRINT_ELLIPSE": //增加椭圆线(Top, Left,Width, Height, intLineStyle, intLineWidth)
                LODOP.ADD_PRINT_ELLIPSE(
                  ele.intTop,
                  ele.intLeft,
                  ele.intWidth,
                  ele.intHeight,
                  ele.intLineStyle,
                  ele.intLineWidth
                );
                break;
              case "LODOP.ADD_PRINT_LINE": //增加直线(Top1,Left1, Top2, Left2,intLineStyle, intLineWidth),用intWidth,intHeight代替Top2,Left2
                LODOP.ADD_PRINT_LINE(
                  ele.intTop,
                  ele.intLeft,
                  ele.intWidth,
                  ele.intHeight,
                  ele.intLineStyle,
                  ele.intLineWidth
                );
                break;
              case "LODOP.ADD_PRINT_TEXTA": //(扩展型)增加纯文本打印项(strItemName,Top,Left,Width,Height,strContent)
                LODOP.ADD_PRINT_TEXTA(
                  ele.name,
                  ele.intTop,
                  ele.intLeft,
                  ele.intWidth,
                  ele.intHeight,
                  ele.strContent.replace('"', "")
                );
                break;
              case "LODOP.ADD_PRINT_BARCODE": //增加条形码(Top, Left,Width, Height, CodeType, CodeValue)
                LODOP.ADD_PRINT_BARCODE(
                  ele.intTop,
                  ele.intLeft,
                  ele.intWidth,
                  ele.intHeight,
                  ele.codeType,
                  ele.codeValue
                );
                break;
              case "LODOP.ADD_PRINT_CHART": //增加图表(Top, Left,Width, Height, ChartType, strHtml)
                LODOP.ADD_PRINT_CHART(
                  ele.intTop,
                  ele.intLeft,
                  ele.intWidth,
                  ele.intHeight,
                  ele.chartType,
                  ele.strContent
                );
                break;
              case "LODOP.ADD_PRINT_TABLE": //增加表格打印项（超文本模式）(Top,Left,Width,Height,strHtml)
                LODOP.ADD_PRINT_TABLE(
                  ele.intTop,
                  ele.intLeft,
                  ele.intWidth,
                  ele.intHeight,
                  ele.strContent
                );
                break;
              case "LODOP.LODOP.ADD_PRINT_URL": //增加超文本打印项（URL模式）(Top,Left,Width,Height,strURL)
                LODOP.ADD_PRINT_URL(
                  ele.intTop,
                  ele.intLeft,
                  ele.intWidth,
                  ele.intHeight,
                  ele.strContent
                );
                break;
              case "LODOP.ADD_PRINT_SHAPE": //(扩展型)增加图形(intShapeType, Top, Left,Width,Height,intLineStyle,intLineWidth, varColor)
                LODOP.ADD_PRINT_SHAPE(
                  ele.intShapeType,
                  ele.intTop,
                  ele.intLeft,
                  ele.intWidth,
                  ele.intHeight,
                  ele.intLineStyle,
                  ele.intLineWidth,
                  ele.intColor
                );
                break;
              case "LODOP.SET_PRINT_STYLE": //设置打印项风格(strStyleName,varStyleValue)
                LODOP.SET_PRINT_STYLE(ele.strStyleName, ele.varStyleValue);
                break;
              case "LODOP.SET_PRINT_STYLEA": //(扩展型)设置打印项风格A(varItemNameID, strStyleName,varStyleValue)
                LODOP.SET_PRINT_STYLEA(
                  ele.varItemNameID,
                  ele.strStyleName,
                  ele.varStyleValue
                );
                break;
              case "LODOP.ADD_PRINT_HTML": //增加超文本打印项(图形模式)(Top,Left,Width,Height, strHtmlContent)
                LODOP.ADD_PRINT_HTML(
                  ele.intTop,
                  ele.intLeft,
                  ele.intWidth,
                  ele.intHeight,
                  ele.strContent
                );
                break;
              case "LODOP.ADD_PRINT_TBURL": //(扩展型)增加表格打印项（URL模式）(Top,Left,Width,Height,strURL)
                LODOP.ADD_PRINT_TBURL(
                  ele.intTop,
                  ele.intLeft,
                  ele.intWidth,
                  ele.intHeight,
                  ele.strContent
                );
                break;
            }
          });
        });
        LODOP.PREVIEW();
      }
    }
  }
  //重新生成
  async regenerate() {
    let val = (this.$refs.selection as any).getSelection();
    if (val.length == 0) {
      this.$Modal.info({
        title: this.L("Tips"),
        content: this.L("PleasChoose") + this.L("One") + this.L("Record"),
      });
      return;
    }
    let ispay = false;
    val.forEach((ele) => {
      if (ele.payMark == 1) {
        ispay = true;
        return;
      }
    });
    if (ispay) {
      this.$Modal.info({
        title: this.L("Tips"),
        content: this.L("CalculationIsRegenerate"),
      });
      return;
    }
    this.reductionpo.billsId = [];
    val.forEach((ele) => {
      this.reductionpo.billsId.push(ele.id);
    });
    let res = await this.$store
      .dispatch({
        type: "bills/regeneratebills",
        data: this.reductionpo,
      })
      .catch((err) => {
        this.$Modal.info({
          title: this.L("Tips"),
          content: err,
        });
      });
    this.$Modal.info({
      title: this.L("Tips"),
      content: res.data.result,
    });
  }
  //减免
  async reduction() {
    let val = (this.$refs.selection as any).getSelection();
    if (val.length == 0) {
      this.$Modal.info({
        title: this.L("Tips"),
        content: this.L("PleasChoose") + this.L("One") + this.L("Record"),
      });
      return;
    }
    let ispay = false;
    val.forEach((ele) => {
      if (ele.payMark == 1) {
        ispay = true;
        return;
      }
    });
    if (ispay) {
      this.$Modal.info({
        title: this.L("Tips"),
        content: this.L("CalculationIsReduction"),
      });
      return;
    }
    this.reductionModalShow = true;
  }
  //计算滞纳金
  async calculationLateFee() {
    let val = (this.$refs.selection as any).getSelection();
    if (val.length == 0) {
      this.$Modal.info({
        title: this.L("Tips"),
        content: this.L("PleasChoose") + this.L("One") + this.L("Record"),
      });
      return;
    }
    this.reductionpo.billsId = [];
    let ispay = false;
    val.forEach((ele) => {
      if (ele.payMark == 1) {
        ispay = true;
        return;
      }
    });
    if (ispay) {
      this.$Modal.info({
        title: this.L("Tips"),
        content: this.L("CalculationIsPayed"),
      });
      return;
    }
    val.forEach((ele) => {
      this.reductionpo.billsId.push(ele.id);
    });
    this.spinShow = true;
    let res = await this.$store
      .dispatch({
        type: "bills/calculationlatefee",
        data: this.reductionpo,
      })
      .catch((err) => {
        this.spinShow = false;
        this.$Modal.info({
          title: this.L("Tips"),
          content: err,
        });
      });
    this.$Modal.info({
      title: this.L("Tips"),
      content: res.data.result,
    });
    this.spinShow = false;
    this.getpage();
  }
  //取消基础费
  async canceBaseFee(data: any) {
    this.reductionpo.billsId.push(data.id);
    this.reductionpo.reductionType = 3; //1为减免滞纳金，2为调整账单，3为取消基础费
    let res = await this.$store
      .dispatch({
        type: "bills/reductionbill",
        data: this.reductionpo,
      })
      .catch((err) => {
        this.btnloading = false;
        this.$Modal.info({
          title: this.L("Tips"),
          content: err,
        });
      });
    this.$Modal.info({
      title: this.L("Tips"),
      content: res.data.result,
    });
    this.btnloading = false;
  }
  //恢复基础费
  async recoveryBaseFee(data: any) {
    this.reductionpo.reductionType = 4; //1为减免滞纳金，2为调整账单，3为取消基础费,4为恢复基础费
    this.reductionpo.billsId.push(data.id);
    let res = await this.$store
      .dispatch({
        type: "bills/reductionbill",
        data: this.reductionpo,
      })
      .catch((err) => {
        this.btnloading = false;
        this.$Modal.info({
          title: this.L("Tips"),
          content: err,
        });
      });
    this.$Modal.info({
      title: this.L("Tips"),
      content: res.data.result,
    });
    this.btnloading = false;
  }
  mounted() {
    if (window.innerHeight > 800) {
      this.height = window.innerHeight - 360;
    } else {
      this.height = window.innerHeight - 100;
    }
  }
}
